export const COVERAGES_TYPES = {
  CLEAR_COVERAGES: "CLEAR_COVERAGES",
  SET_COVERAGES: "SET_COVERAGES",
  SET_ROUTE_CYCLES: "SET_ROUTE_CYCLES",
  SET_SELECTED_COVERAGE: "SET_SELECTED_COVERAGE",
  SET_CANCEL_MOTIVES: "SET_CANCEL_MOTIVES",
  SET_BRANDS: "SET_BRANDS",

  // new coverage
  ADD_COVERAGE: "ADD_COVERAGE",
  NEW_COVERAGE: "NEW_COVERAGE",
  SEND_NEW_COVERAGE: "SEND_NEW_COVERAGE",
  SET_NEW_COVERAGE: "SET_NEW_COVERAGE",
  DELETE_COVERAGE_MODE: "DELETE_COVERAGE_MODE",

  EDIT_COVERAGE_MODE: "EDIT_COVERAGE_MODE",
  SET_EDITED_COVERAGE: "SET_EDITED_COVERAGE",
  DELETE_COVERAGE: "DELETE_COVERAGE",
  SET_DELETED_COVERAGE: "SET_DELETED_COVERAGE",
  HANDLE_COVERAGES_INPUTS: "HANDLE_COVERAGES_INPUTS",
};
